module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('agent-selector', {
    attrs: {
      "reservation": _vm.reservation
    },
    on: {
      "sideBarOriginAndSegmentIsReadyToSubmit": function ($event) { return _vm.sideBarOriginAndSegmentIsReadyToSubmit = $event; }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-lightest dark font-weight-600 px-3 py-3 fs-small d-flex flex-row align-items-center justify-content-between pointer w-100"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "w-50 d-flex justify-content-end"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.BookingOperatorCode),
      expression: "reservation.BookingOperatorCode"
    }],
    staticClass: "w-100 px-2 py-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.reservation.BookingOperatorCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation, "BookingOperatorCode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('cost-list', {
    attrs: {
      "reservation": _vm.reservation,
      "noTicketsSelected": _vm.perOrderNoCategories
    }
  }), _vm._v(" "), _c('promocode-input', {
    staticClass: "mt-2",
    attrs: {
      "reservation": _vm.reservation,
      "enablePromocode": true,
      "noTicketsSelected": _vm.perOrderNoCategories
    }
  }), _vm._v(" "), _c('total-and-pay', {
    attrs: {
      "reservation": _vm.reservation,
      "selectedAgentComissions": _vm.selectedAgentComissions,
      "noTicketsSelected": _vm.perOrderNoCategories,
      "sideBarOriginAndSegmentIsReadyToSubmit": _vm.sideBarOriginAndSegmentIsReadyToSubmit
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-row align-items-center"
  }, [_c('i', {
    staticClass: "ico ico-ticket color-6 fs-larger"
  }), _vm._v(" "), _c('span', [_vm._v("VOUCHER CODE")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-2f836c7b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f836c7b"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/NewReservation/Resume/ReservationSummary.vue
// module id = 2936
// module chunks = 0